<div class="header">
	<h3 translate="drafts-snackbar-title"></h3>
	<button
		class="close-btn"
		type="button"
		(click)="close()"
		[attr.aria-label]="'common_close' | translate">
		<i class="ficon-app-x"></i>
	</button>
</div>
<div class="image">
	<img src="https://staticassets.goreact.com/drafts.png" alt="astronaut-astroid">
</div>
<p class="message">{{ getMessageTranslation() | translate }}</p>
<div class="action-wrapper">
	<a class="tertiary-btn" href="https://help.goreact.com/hc/en-us/articles/28242837294989-Restart-or-Draft-Your-Video" target="_blank" rel="noopener noreferrer" translate="common_learn-more"></a>
	<button class="primary-btn" (click)="close()" translate="common_done"></button>
</div>
